import { useEffect, useState } from 'react';
import { getSnapshot, setFilters, subscribe, type RadarSnapshot } from '../services/radarStore';
import type { RadarFilters } from '../types/market';

/**
 * Thin subscription to the singleton radar store. The radar worker and all
 * predictor state live in `radarStore` at module scope, so unmounting this
 * hook (e.g. navigating to a coin page) does not stop the radar; the list is
 * immediately available when the dashboard is visited again.
 */
export function useMarketRadar(filters: RadarFilters): RadarSnapshot {
  const [snapshot, setSnapshot] = useState<RadarSnapshot>(() => getSnapshot());

  useEffect(() => {
    setFilters(filters);
    return subscribe(setSnapshot);
  }, [filters]);

  return snapshot;
}
